import { useEffect, useRef, useState } from 'react';
import { FileUploader } from "react-drag-drop-files";
import { useDispatch } from 'react-redux';
import { setSubLoading } from '../../Redux/Services/AuthSlice';
import { NotificationSound } from '../CommonComponents/CommonNotification';
import { ApiCall, FileUploadChild, OpenImage, convertToNumber, deleteData, handleDateChange, initializeFilterData } from '../CommonComponents/CustomHooks';
import {  FormButton, InputBox, Switch } from '../CommonComponents/InputBox';
import { Table } from '../CommonComponents/Table';

const ClientMaster = () => {
    const inputrefs = useRef([])
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const [edit, setEdit] = useState(false)
    const [tableData, setTableData] = useState([])
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const [filterData, setFilterData] = useState(initializeFilterData)
    const [sortConfig, setSortConfig] = useState({ SortColumn: null, SortOrder: null });
    const [formData, setFormData] = useState({
        ClientMasterID: '',
        clientCode: 'System Generated',
        clientName: '',
        helpLineNo: '',
        helpDeskEmailID:"",
        password:'',
        isActive: true,
        isOTPRequired: true,
        isAllowCaptcha: false,
        isEnableLogin: false,
    });

    const getClientMasterData = async (CurrentPage) => {
        let PageIndex = 1
        if (CurrentPage !== undefined && typeof (CurrentPage) !== "object") {
            PageIndex = CurrentPage;
            setCurrentPageNo(CurrentPage);
        }
        else {
            setCurrentPageNo(1);
        }
        const data = {
            ...filterData,
            Type: 'S',
            PageIndex: `${PageIndex}`,
            ...sortConfig,
        }
        setIsLoading(true)
        let res = await ApiCall(`/api/Master/ShowClientMaster`, data)
        if (res.Status === "SUCCESS") {
            setTableData(res)
        }
        if (res.Status === "ERROR") {
            setTableData([])
        }
        setIsLoading(false)
        if (res.Status === 'EXPIRED') {
            await NotificationSound(res.Status, res.Message, res.focus, inputrefs);
        }
    }

    const handleClear = async () => {
        setFormData({
            ClientMasterID: '',
            clientCode: 'System Generated',
            clientName: '',
            helpLineNo: '',
            helpDeskEmailID: "",
            password:'',
            isActive: true,
            isOTPRequired: true,
            isAllowCaptcha:false,
            isEnableLogin: false,
        });
        filterData.SearchText = '';
        setEdit(false)
        getClientMasterData();
    }
    const handleView1 = (url) => {
        window.open(url, "_blank");
    };
    const handleSubmit = async () => {
        await dispatch(setSubLoading(true))
        let data = await ApiCall(`/api/Master/InsertUpdateClientMaster`, { ...formData })
        await dispatch(setSubLoading(false))
        setEdit(false)
        await NotificationSound(data.status, data.message, data.focus, inputrefs, handleClear);
    };

    const handleEditData = async (id) => {
        await dispatch(setSubLoading(true))
        let editData = await ApiCall(`/api/Master/EditClientMaster`, { ClientMasterID: id })
        await dispatch(setSubLoading(false))
        setEdit(true)
        if (editData.status === 'UNAUTHORIZED' || editData.status === 'ERROR' || editData.status === 'EXPIRED') {
            await NotificationSound(editData.status, editData.message, editData.focus, inputrefs);
        }
        else if (editData.status === 'SUCCESS') {
            let record = editData.data
            setFormData((pre) => ({
                ...pre, ...record
            }))
        }
    }

    const handleDelete = async (id) => {
        await dispatch(setSubLoading(true))
        await deleteData(`/api/Master/DeleteClientMaster`, { ClientMasterID: id }, getClientMasterData, handleClear, '', inputrefs)
        await dispatch(setSubLoading(false))
    }
    const handleChange1 = (client, value) => {
        getClientMasterData(value);
    };

    const handleSorting = (SortColumn) => {
        let SortOrder = 'ASC';
        if (sortConfig && sortConfig.SortColumn === SortColumn && sortConfig.SortOrder === 'ASC') {
            SortOrder = 'DESC';
        }
        setSortConfig({ SortColumn, SortOrder });
    };

    
    useEffect(() => {
        getClientMasterData()
        document.title = 'Client Master'
        inputrefs.current['txtClientName'].focus()
    }, [sortConfig])

    return (
        <>
            <div className='main-card card border-0'>
                <div className='pt-1 row px-3 border-0'>
                    <div className='card-header mb-1'>
                        <h6 className="m-0">  {'Client Master'} </h6>
                    </div>
                    <div className='card-body pb-1 row'>
                        <div className='col-md-12 col-lg-12'>
                            <div className='row'>
                                <InputBox
                                    id="txtClientCode"
                                    label='Client Code'
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtClientName'].focus()
                                        }
                                    }}
                                    disabled={true}
                                    inputrefs={inputrefs}
                                    maxLength='10'
                                    placeholder='System Generated'
                                    name='ClientCode'
                                    value={formData.clientCode}
                                    onChange={(e) => setFormData({ ...formData, clientCode: e.target.value })}
                                />
                                <InputBox
                                    id="txtClientName"
                                    type="text"
                                    label='Client Name'
                                    required={true}
                                    placeholder="Client Name"
                                    maxLength='50'
                                    value={formData.clientName}
                                    onChange={(e) => setFormData({ ...formData, clientName: e.target.value })}
                                    inputrefs={inputrefs}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtHelplineNo'].focus()
                                        }
                                    }}
                                />
                                <InputBox
                                    id="txtHelplineNo"
                                    placeholder="Helpline No"
                                    autoComplete="off"
                                    maxLength='15'
                                    label='Helpline No'
                                    required={true}
                                    value={formData.helpLineNo}
                                    onChange={(e) => setFormData({ ...formData, helpLineNo: convertToNumber(e.target.value) })}
                                    inputrefs={inputrefs}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtHelpDeskEmailID'].focus()
                                        }
                                    }}
                                />
                                <InputBox
                                    id="txtHelpDeskEmailID"
                                    placeholder="Help Desk EmailID "
                                   
                                    label='Help Desk EmailID'
                                    value={formData.helpDeskEmailID}
                                    onChange={(e) => setFormData({ ...formData, helpDeskEmailID: e.target.value})}
                                    inputrefs={inputrefs}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtPassword'].focus()
                                        }
                                    }}
                                />
                                <InputBox
                                    id="txtPassword"
                                    placeholder="Password"
                                    autoComplete="off"
                                    maxLength='15'
                                    minLength='8'
                                    label='Password'
                                    disabled={edit}
                                    required={true}
                                    value={formData.password}
                                    onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                                    inputrefs={inputrefs}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtIsOTPRequired'].focus()
                                        }
                                    }}
                                />
                       
                                <Switch
                                    inputrefs={inputrefs}
                                    label='OTP Required'
                                    checked={formData.isOTPRequired}
                                    divclassname="col-lg-3 col-md-2"
                                    id='txtIsOTPRequired'
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtIsAllowCaptcha'].focus()
                                        };
                                    }}
                                    onChange={(e) => setFormData({ ...formData, isOTPRequired: e.target.checked })}
                                />
                                <Switch
                                    inputrefs={inputrefs}
                                    label='Allow Captcha'
                                    checked={formData.isAllowCaptcha}
                                    divclassname="col-lg-3 col-md-2 "
                                    id='txtIsAllowCaptcha'
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtEnableLogin'].focus()
                                        };
                                    }}
                                    onChange={(e) => setFormData({ ...formData, isAllowCaptcha: e.target.checked })}
                                />
                                <Switch
                                    inputrefs={inputrefs}
                                    label='Login Allowed'
                                    checked={formData.isEnableLogin}
                                    divclassname="col-lg-3 col-md-2 "
                                    id='txtEnableLogin'
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtActive'].focus()
                                        };
                                    }}
                                    onChange={(e) => setFormData({ ...formData, isEnableLogin: e.target.checked })}
                                />
                                <Switch
                                    inputrefs={inputrefs}
                                    label='Active'
                                    checked={formData.isActive}
                                    divclassname="col-lg-3 col-md-2 "
                                    id='txtActive'
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['btnSub'].focus()
                                        };
                                    }}
                                    onChange={(e) => setFormData({ ...formData, isActive: e.target.checked })}
                                />
                               
                            </div>
                        </div>
                        <div className='card-body'>
                            <FormButton
                                id={'btnSub'}
                                inputrefs={inputrefs}
                                handleSubmit={handleSubmit}
                                Export={false}
                                handleClear={handleClear}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <Table
                handleEdit={handleEditData}
                handleDelete={handleDelete}
                loading={isLoading}
                PageName={'ClientMaster'}
                handleFilter={() => {
                    getClientMasterData()
                    setFilterData({
                        ...filterData,
                    })
                }}
                handleView1={handleView1}
                filterData={filterData}
                tableData={tableData}
                setFilterData={setFilterData}
                currentPageNo={currentPageNo}
                handleChange1={handleChange1}
                handleSorting={handleSorting}
                sortConfig={sortConfig}
            />
        </>
    )
}
export default ClientMaster;